(function($) {
	$.fn.dynamicListBoxes = function(options) {

        $(this).each(function () {
            var element = $(this);
            element.data('val', element.val());
            var form = element.closest("form");
            var mdata = element.metadata();
            if (mdata && mdata.refreshAction && mdata.params)
            {
                $.each(mdata.params, function (idx, item) {
                    var paramElement = findItem(item, form);
                    if (paramElement.length > 0)
                    {
                        var refreshDynamic = function() {
                            var originalVal = paramElement.data('val');
                            var waitCount = 0;
                            // Don't load the list until none of the dependent lists are mutating, otherwise we may read the wrong val()
                            var interval = window.setInterval(function () {
                                if(waitCount > 100) {
                                    // max wait
                                    clearInterval(interval);
                                }
                                var anyWaiting = false;
                                $.each(mdata.params, function (idx, item) {
                                    var paramElement = findItem(item, form);
                                    if(paramElement.find('.loading').length > 0) {
                                        anyWaiting = true;
                                    }
                                });
                                if(!anyWaiting) {
                                    // ready to proceed
                                    clearInterval(interval);
                                    if (originalVal != paramElement.val() || mdata.forceRefresh) {
                                        paramElement.data('val', paramElement.val());
                                        refreshDynamicThing(element, form);
                                    }
                                }
                                waitCount++;
                            },100);
                        };

                        var eventName = 'change';
                        if((paramElement.is('.dropdownlist') && paramElement.siblings('select').prop('multiple')) || paramElement.is('.dropdowntree')) {
                            // Use close event on a drop down list so that the event is only fired once when the user checks multiple options
                            eventName = 'close';
                        }

                        /**
                         * Remove the handler on param element when dependant element is removed from DOM
                         * to avoid duplicate binding when replacing only dependant elements.
                         */
                        element.on('remove', function() {
                            paramElement.off(eventName, refreshDynamic);
                        });

                        paramElement.on(eventName, refreshDynamic);
                    }
                });
            }
        });
	};

})(jQuery);

function findItem(selector, $form) {
    var element = $form.find(selector);
    if(element.size()==0) {
        /* could not find a matching field, however if the selector is an #id then it may have been renamed by uniqueFormInputIds so check for #id_{123} */
        var regex = /^#[A-Za-z]+[\w\-]*$/;
        if(regex.test(selector)) {
            element = $form.find('[id^='+selector.substr(1)+'_]').filter(':not(:disabled)');
        }
    }
    return element;
}


function refreshDynamicThing(element, form)
{
    var form = element.closest("form");
    var params = {};
    var mdata = element.metadata();
    $.each(mdata.params, function (idx, item) {
        var paramElement = findItem(item, form);
        if (paramElement.length == 1)
        {
            // Case when multiple hidden fields for single jqx widget
            var inputs = paramElement.find('input');
            if (inputs.length > 1)
            {
                $.each(inputs, function (idx, item) {
                    params[item.name] = item.value;
                });
            }
            else
            {
                // e.g. params[idDealer] = 13758
                var val = paramElement.val();
                params[item.beginsWith("#") ? item.substring(1) : item] = val || '';
            }
        }
        else if(paramElement.length >  1) {
            params[item] = paramElement.fieldValue();
        }
    });
    var className = element[0].className;
    if (className.indexOf('dynamicListBox')>=0)
    {
        element.data('kept-value', element.val());
        if(element.is('.dropdownlist')) {
            element.jqxDropDownList({ disabled: true });
            element.find('.jqx-icon-arrow-down').addClass("loading");
        }
        else {
            element.prop('disabled', true);
            element.addClass("loading");
            element.val('');
        }
        $.ajax({
            url: mdata.refreshAction,
            data: params,
            dataType: 'json',
            traditional: true,
            success: function (data) {
                if(element.is('.dropdownlist')) {
                    refreshDynamicDropdownlistDataReceived(element, data);
                }
                else {
                    refreshDynamicListBoxDataReceived(element, data);
                }

                element.trigger('list_updated');
            }
        });
    }
    else if (className.indexOf('dynamicListCheckBoxes')>=0)
    {
        var keptVal = [];
        element.find(':checkbox:checked').each(function() {
            keptVal.push($(this).val());
        });
        element.data('kept-value', keptVal);
        element.addClass("loading").find(':checkbox').prop('disabled',true);
        $.ajax({
            url: mdata.refreshAction,
            data: params,
            dataType: 'json',
            traditional: true,
            success: function(data) {refreshDynamicCheckBoxesDataReceived(element, data);}
        });
    }
    else
    {
        element.addClass("loading");
        $.ajax({
            url: mdata.refreshAction,
            data: params,
            dataType: 'html',
            traditional: true,
            success: function(data) {refreshDynamicBlockDataReceived(element, data);}
        });
    }
}

// IMPORTANT NOTE:
// The dynamic block thing replaces the first child, since it's much simpler to replace the content than the element
// itself - that way the event handler would get broken and have to be set up again every time the element was replaced.
function refreshDynamicBlockDataReceived(element, data)
{
    // TODO check for error in response, handle
    var elementToReplace = element.find(":first");
    var elementId = elementToReplace.attr("id");
    var jqData = $(data);
    // look for element with matching id in returned data, including the root node of the data
    var replacement = (jqData.attr("id")==elementId) ? jqData : $(data).find("#" + elementId);
    // if found, replace element in page with element returned
    if (replacement.length == 1)
    {
        elementToReplace.empty().replaceWith(replacement);
    }
    element.removeClass("loading");
    element.msxiinit();
    element.trigger('block_updated');
}
/**
 * Replace the select box options with the JSON data
 * @param listBox - The select list box whose elements are to be replaced
 * @param data - The json data
 */
function refreshDynamicListBoxDataReceived(listBox, data)
{
    var originalVal = listBox.val();
    var mdata = listBox.metadata();
    if (mdata && mdata.keepItems)
    {
        var keptItems = [];
        listBox.find('option:lt(' + mdata.keepItems + ')').each(function(){
            keptItems[keptItems.length] = $(this)[0].cloneNode(true);
        });
        listBox.empty();
        $(keptItems).each(function(){
            listBox.append(this);
        });
    }
    else
    {
        listBox.empty();
    }

    var group = '';
    var $container = listBox;

    $(data.listItems).each(function() {
        if(this.group && this.group != group) {
            group  = this.group;
            var $optgroup = $('<optgroup label="' + this.group + '" />');
            listBox.append($optgroup);
            $container = $optgroup;
        }
        else if(!this.group && group) {
            group = '';
            $container = listBox;
        }

        var $option = $('<option value="' + this.value + '">' + this.name + '</option>');
        if(this.disabled) {
            $option.attr('disabled', 'disabled');
        }
        if(this.cssClass) {
            $option.attr('class', this.cssClass);
        }
        $container.append($option);
    });
    if (mdata && mdata.keepValue)
    {
        var keptValue = listBox.data('kept-value');
        listBox.val(keptValue);
    }
    if (listBox.val() != originalVal) {
        listBox.trigger('change');
    }
    if(listBox.find('option:selected').is('.default-option')) {
        listBox.addClass('default-option');
    }
    listBox.prop('disabled', false).removeClass("loading");
}
function refreshDynamicDropdownlistDataReceived(listBox, data)
{
    var mdata = listBox.metadata();
    var items = [];
    if (mdata && mdata.keepItems)
    {
        var i = 0;
        var j = 0;
        while(i < mdata.keepItems) {
            var keptItem = listBox.jqxDropDownList('getItem', j);
            if(!keptItem) {
                // not found
                break;
            }
            else if (!keptItem.isGroup) {
                items[i] = {group: keptItem.group, value: keptItem.value, label: keptItem.label, disabled: keptItem.disabled, html: keptItem.html};
                i++;
            }
            j++;
        }
    }

    var keptValue = '';
    var keptItems = [];
    if (mdata && mdata.keepValue)
    {
        keptValue = listBox.data('kept-value');
    }
    $(data.listItems).each(function() {
        var item = {};
        item.group = this.group;
        item.value = this.value;
        item.label = this.name;
        item.disabled = this.disabled || false;
        if(this.cssClass) {
            item.html = '<span class="'+this.cssClass+'">'+this.name+'</span>';
        }
        items.push(item);
        if (keptValue && keptValue.split(",").indexOf(item.value) > -1)
        {
            keptItems.push(item);
        }
    });
    listBox.jqxDropDownList({source: items});
    if (mdata && mdata.keepValue)
    {
        listBox.val(keptValue);
        if (listBox.val() === '' && keptItems.length > 0)
        {
            for (var n = 0; n < keptItems.length; n++)
            {
                listBox.jqxDropDownList('checkItem', keptItems[n]);
            }
        }
    }

    listBox.jqxDropDownList({ autoDropDownHeight: items.length < 20 });

    if(listBox.val() == '') {
        listBox.addClass('default-option');
    }
    else {
        listBox.removeClass('default-option');
    }
    listBox.jqxDropDownList({ disabled: false });
    listBox.find('.jqx-icon-arrow-down').removeClass("loading");
}


/**
 * Replace the check boxes div with the JSON data received
 * @param element - The div whose elements are to be replaced
 * @param data - The json data
 */
function refreshDynamicCheckBoxesDataReceived(element, data)
{
    var mdata = element.metadata();
    var id = element.find("label:first").attr("for");
    if (id === undefined) {
        return;
    }
    var checkBoxesDiv = element.find(".form-checkboxes");
    checkBoxesDiv.empty();
    var idx = 0;
    var group = '';
    var supportElementHiding = mdata.hideElementWhenNoItems || false;

    if (data.listItems.length > 0)
    {
        element.show();
    }
    else
    {
        if (supportElementHiding)
        {
            element.hide();
        }
        if (mdata.emptyOptionMessage)
        {
            checkBoxesDiv.append('<div>' + mdata.emptyOptionMessage + '</div>');
        }
    }

    $(data.listItems).each(function() {
        //inline with sanitiseId generation in freemarker
        var elementId = id.replace('.', '_').replace('[', '_').replace(']', '').replace('\'','') +'_'+idx++;
        if(this.group && this.group != group) {
            checkBoxesDiv.append('<div class="form-checkbox-group">'+this.group+'</div>');
            group = this.group;
        }
        var $checkbox = $('<input type="checkbox" id="'+elementId+'" name="'+id+'" value="'+this.value+'"/>');
        if(this.disabled) {
            $checkbox.attr('disabled', 'disabled');
        }
        if(mdata && mdata.keepValue) {
            if (element.data('kept-value').indexOf(this.value) > -1) {
                $checkbox.attr('checked', 'checked');
            }
        }
        var $formCheckbox = $('<div class="form-checkbox" />');
        if(this.cssClass) {
            if(this.applyCssClassToParent){
                $formCheckbox.addClass(this.cssClass);
            }
            else {
                $checkbox.attr('class', this.cssClass);
            }
        }
        var tooltip = mdata.toolTips ? 'title="'+this.name+'"' : '';
        $formCheckbox.append($checkbox).append('<label for="'+elementId+'" '+tooltip+'>'+this.name+'</label>');
        checkBoxesDiv.append($formCheckbox);
    });

    // Column information may be stored in metadata
    var metadata = element.metadata();
    if(metadata['column-size']) {
        var columns = (data.listItems.length / metadata['column-size']) + 1;
        if(metadata['max-columns'] && columns > metadata['max-columns']) {
            columns =  metadata['max-columns'];
        }
        checkBoxesDiv.addClass('columns-' + columns);
    }

    checkBoxesDiv.filter('.addCheckAll').msxicheckall_addcheckall();
    element.find('input.checkAll:checkbox, a.checkAll').prop('checked', false).msxicheckall();
    checkBoxesDiv.filter('.checkHider').msxicheckhider();
    if($.fn.productrole){
        $('#product-role').productrole();
    }
    element.removeClass("loading").find('.checkAll:checkbox').prop('disabled', false);
}